import React from 'react'
import {Header} from '../components/Header';
import { Footer } from '../components/Footer';
import VisitUs from '../components/VisitUs';


const VisitPage = () => {
  return (
    <div>
      <Header />
     <VisitUs/>
      <Footer />
    </div>
  )
}

export default VisitPage;